import { CtaShell } from "./cta-shell"
import type { CtaShellProps } from "./cta-types"

export type AudienceTabbedCtaProps = CtaShellProps

export function AudienceTabbedCta(props: AudienceTabbedCtaProps) {
  return <CtaShell {...props} layout="tabbed" audiences={props.audiences ?? [
    { label: "Founders", headline: "Launch the page that makes the idea legible.", supportingLine: "Move from vague concept to a conversion-ready site with proof and clear next steps.", primaryCta: { label: "Start launch", href: "#founders" } },
    { label: "Teams", headline: "Give every campaign a stronger starting point.", supportingLine: "Use reusable CTA patterns that fit demos, trials, reports, and sales conversations.", primaryCta: { label: "Build campaign", href: "#teams" } },
  ]} />
}
